export default __webpack_public_path__ + "static/media/welcome-bonus-ico.4dfd12ff.svg";